import {
  Box,
  Card,
  FormLayout,
  TextField,
  InlineStack,
  Select,
  Tooltip,
  Tag,
} from "@shopify/polaris";

const BundleBasicDetails = ({
  name,
  setName,
  editable,
  vendor,
  setVendor,
  setStatus,
  status,
  description,
  setDescription,
  newTag,
  handleAddTag,
  setNewTag,
  sku,
  setSku,
  categories,
  setCategory,
  category,
  tags,
  handleRemoveTag,
}) => {
  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Draft", value: "draft" },
  ];
  return (
    <Card title="Bundle Basic Details" sectioned>
      <FormLayout>
        <InlineStack align="space-between">
          <Box width="33%">
            <TextField
              placeholder="e.g. Luxury Perfume set"
              label="Bundle Name"
              value={name}
              onChange={(value) => setName(value)}
              disabled={!editable}
            />
          </Box>
          <Box width="33%">
            <TextField
              label="Brand Name"
              value={vendor}
              placeholder="e.g. Boat"
              onChange={(value) => setVendor(value)}
              disabled={!editable}
            />
          </Box>
          <Box width="33%">
            <Select
              disabled={!editable}
              label="Status"
              options={statusOptions}
              onChange={setStatus}
              value={status}
            />
          </Box>
        </InlineStack>
        <TextField
          label="Description"
          value={description}
          placeholder="Write a detailed description about your bundle..."
          onChange={(value) => setDescription(value)}
          multiline={4}
          disabled={!editable}
        />
        <InlineStack align="space-between" spacing="tight">
          <div
            onKeyDown={(e) => {
              if (e.code === "Enter") {
                handleAddTag();
              }
            }}
          >
            <Tooltip
              content="Add relevant tags to optimize search, improve category placement, and aid consumer navigation. (e.g., Birthday, For her, For Him, Festive, Luxury)"
              hasUnderline
            >
              <TextField
                label="Add Tag"
                value={newTag}
                onChange={(value) => {
                  setNewTag(value);
                }}
                placeholder="Enter tags"
                disabled={!editable}
              />
            </Tooltip>
          </div>
          {/* <TextField
            label="SKU"
            value={sku}
            onChange={(value) => {
              setSku(value);
            }}
            placeholder="Enter SKU"
            disabled={!editable}
          /> */}

          <Select
            label="Select Product Category"
            onChange={(value) => setCategory(value)}
            options={[
              { label: "Select a category", value: "" },
              ...categories.map((c) => {
                return {
                  label: c.title,
                  value: c._id,
                };
              }),
            ]}
            disabled={!editable}
            value={category}
          />
        </InlineStack>
        <Box marginTop="4">
          {tags.length > 0 && (
            <InlineStack gap="100">
              {tags.map((tag, index) => (
                <Tag
                  disabled={!editable}
                  key={index}
                  onRemove={() => handleRemoveTag(tag)}
                >
                  {tag}
                </Tag>
              ))}
            </InlineStack>
          )}
        </Box>
      </FormLayout>
    </Card>
  );
};

export default BundleBasicDetails;
